import React, { useState, useEffect } from "react";
import { useFirebase } from "../../database/FirebaseContext";

function TaskForm({ task, closeModal }) {
  const { editPBTask,getAllUsersData } = useFirebase();
  const [userList,setUserList] = useState([])
  

  const [editableTask, setEditableTask] = useState(task);
  useEffect(() => {
    const { elements } = document.querySelector("form");

    for (const [key, value] of Object.entries(editableTask)) {
      const field = elements.namedItem(key);
      field && (field.value = value);
    }

    const getUserList = async ()=>{
      const rawUserList = await getAllUsersData()
      const nameList = rawUserList.map((user)=>{
        return user.userName
      })
      setUserList(nameList)
      
    }
    getUserList()
      }, []);

  const handleChange = (event) => {
    const { name, value, type } = event.target;

    // extract the string value of selected option and place it in an array
    if (type === "select-multiple") {
      const optionsArr = [...event.target.options];
      const newCategoryTag = optionsArr
        .filter((currOption) => currOption.selected)
        .map((currOption) => currOption.value);

      setEditableTask((prevData) => ({
        ...prevData,
        [name]: newCategoryTag,
      }));
    } else {
      setEditableTask((values) => ({ ...values, [name]: value }));
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const priorityValue = {
      Low: 1,
      Medium: 2,
      Important: 3,
      Urgent: 4,
    };
    const data = {
      ...editableTask,
      taskStatus: "NotStarted",
      taskPriority: priorityValue[editableTask.taskPriority],
    };
    editPBTask(editableTask.id, data);
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <div className="title">
          <p className="titleheader">Edit Task</p>
        </div>
        <div className="content">
          <div className="content-container">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Task Name */}
                <div className="box-for-text-content">
                  <label for="taskName">
                    <span class="text-content">Name</span>
                  </label>
                </div>
                <input
                  className="box text-for-tag"
                  type="text"
                  id="taskName"
                  name="taskName"
                  value={editableTask.taskName || ""}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Type */}
              <div className="row">
                <div className="box-for-text-content">
                  <span className="text-content">
                    <label for="taskType">Type</label>
                  </span>
                </div>
                <div className="type">
                  <div className="type-tick-bug">
                    <input
                      type="radio"
                      id="bug"
                      name="taskType"
                      value="Bug"
                      onChange={handleChange}
                      required
                    />
                    <label for="bug">
                      <span className="text-for-tick">Bug</span>
                    </label>
                  </div>
                  <div className="type-tick-default">
                    <input
                      type="radio"
                      id="dStory"
                      name="taskType"
                      value="Default Story"
                      onChange={handleChange}
                      required
                    />
                    <label for="dStory">
                      <span className="text-for-tick">Default Story</span>
                    </label>
                  </div>
                </div>
              </div>

              {/* Story Point */}
              <div className="row">
                <div className="box-for-text-content">
                  <label for="taskStoryPoint" className="text-content">
                    Story Point
                  </label>
                </div>

                <div className="type">
                  <div className="story-point-box">
                    <input
                      style={{
                        backgroundColor: "#616675",
                        color: "white",
                        borderStyle: "none",
                      }}
                      type="number"
                      id="taskStoryPoint"
                      name="taskStoryPoint"
                      min="0"
                      max="10"
                      value={editableTask.taskStoryPoint || ""}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Category Tag */}
              <div className="row">
                <div className="box-for-text-content">
                  <label for="taskTag" className="text-content">
                    Tag
                  </label>
                </div>

                <div
                  className="box"
                  style={{
                    paddingLeft: "0px",
                    paddingRight: "0px",
                  }}
                >
                  <select
                    className="pl-[5px]"
                    name="taskTag"
                    id="taskTag"
                    type="checkbox"
                    onChange={handleChange}
                    multiple
                    style={{
                      height: "22px",
                      backgroundColor: "#616675",
                      color: "white",
                      borderStyle: "none",
                      width: "100%",
                    }}
                  >
                    <option value="Frontend">Frontend</option>
                    <option value="Backend">Backend</option>
                    <option value="API">API</option>
                    <option value="Database">Database</option>
                    <option value="Testing">Testing</option>
                    <option value="UI">UI</option>
                    <option value="Framework">Framework</option>
                    <option value="UX">UX</option>
                  </select>
                </div>
              </div>

              {/* Priority */}
              <div className="row">
                <div className="box-for-text-content">
                  <label for="taskPriority" className="text-content">
                    Priority
                  </label>
                </div>

                <div className="type">
                  <div className="p-type-tick-green">
                    <input
                      type="radio"
                      id="low"
                      name="taskPriority"
                      value={"Low"}
                      onChange={handleChange}
                    />
                    <label for="low">
                      <span className="text-for-tick">Low</span>
                    </label>
                  </div>

                  <div className="p-type-tick-yellow">
                    <input
                      type="radio"
                      id="medium"
                      name="taskPriority"
                      value={"Medium"}
                      onChange={handleChange}
                    />
                    <label for="medium">
                      <span className="text-for-tick">Medium</span>
                    </label>
                  </div>

                  <div className="p-type-tick-orange">
                    <input
                      type="radio"
                      id="important"
                      name="taskPriority"
                      value={"Important"}
                      onChange={handleChange}
                    />
                    <label for="important">
                      <span className="text-for-tick">Important</span>
                    </label>
                  </div>

                  <div className="p-type-tick">
                    <input
                      type="radio"
                      id="urgent"
                      name="taskPriority"
                      value={"Urgent"}
                      onChange={handleChange}
                    />
                    <label for="urgent">
                      <span className="text-for-tick">Urgent</span>
                    </label>
                  </div>
                </div>
              </div>

              {/* Description */}
              <div className="row">
                <div className="box-for-text-content-description">
                  <span className="text-content">
                    <label for="taskDescription">Description</label>
                  </span>
                </div>

                <textarea
                  className="box-description"
                  name="taskDescription"
                  id="taskDescription"
                  cols="30"
                  rows="10"
                  value={editableTask.taskDescription || ""}
                  onChange={handleChange}
                  style={{ color: "white" }}
                  required
                ></textarea>
              </div>

              {/* status */}
              <div className="row-status">
                <div
                  className="box-for-text-content"
                  style={{ paddingRight: "9px" }}
                >
                  <span className="text-content">
                    <label for="taskStatus">Status</label>
                  </span>
                </div>

                <div className="box">
                  <select
                    name="taskStatus"
                    id="taskStatus"
                    onChange={handleChange}
                    style={{
                      backgroundColor: "#616675",
                      color: "white",
                      borderStyle: "none",
                      width: "100%",
                    }}
                  >
                    <option value="NotStarted">NotStarted</option>
                    <option value="InProgress">InProgress</option>
                    <option value="Completed">Completed</option>
                  </select>
                </div>
              </div>

              {/* Stage */}
              <div className="row">
                <div className="box-for-text-content">
                  <span className="text-content">
                    <label for="taskStage">Stage</label>
                  </span>
                </div>

                <div
                  className="box"
                  style={{
                    paddingLeft: "0px",
                    paddingRight: "0px",
                  }}
                >
                  <select
                    name="taskStage"
                    id="taskStage"
                    onChange={handleChange}
                    style={{
                      backgroundColor: "#616675",
                      color: "white",
                      borderStyle: "none",
                      width: "100%",
                    }}
                  >
                    <option value="Planning">Planning</option>
                    <option value="Development">Development</option>
                    <option value="Testing">Testing</option>
                    <option value="Integration">Integration</option>
                  </select>
                </div>
              </div>

              <div className="row">
                {/* Task Assignee */}
                <div className="box-for-text-content">
                  <label for="taskAssignee">
                    <span class="text-content">Assignee</span>
                  </label>
                </div>
                <div className="box" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
                  <select
                    name="taskAssignee"
                    id="taskAssignee"
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      backgroundColor: "#616675",
                      color: "white",
                      borderStyle: "none",
                    }}
                  >
                    {userList.map((str) => (
                      <option key={str} value={str}>
                        {str}
                      </option>
                    ))}
                    
                  </select>
                </div>
              </div>

              <div className="btn-container-create-task">
                <button
                  type="submit"
                  value="save"
                  className="save bg-[#616675]"
                >
                  Save
                </button>
                <button className="close" onClick={closeModal}>
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
export default TaskForm;
